import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ConfirmationPopUp from "../MessageBox/ConfirmationPopUp";
import UserManagementActions from "../../Actions/UserManagementActions";
import UsermanagementConstants from "../../Constants/UsermanagementConstants";
import usermanagementStore from "../../Stores/UsermanagementStore";
import { useLanguageContext } from "../../Context/LanguageContext";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import AddIcon from "@mui/icons-material/Add";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import BuildingActions from "../../Actions/BuildingActions";
import buildingStore from "../../Stores/BuildingStores";
import BuildingConstant from "../../Constants/BuildingConstants";
import AddBuilding from "./AddBuilding";
import commonUtils from "../../helpers/commonUtils";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { Button } from "@mui/material";
import ImportComponent from "../ReusableComponent/ImportComponent/importComponent";
import ImportAction from "../../Actions/ImportAction";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
export default function BuildingList() {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [confirmationPopUpOpen, setConfirmationPopUpOpen] = useState(false);
  const [confirmationPopUpMsg, setConfirmationPopUpMsg] = useState("");
  const [callbackData, setCallbackData] = useState(null);
  const [eventType, setEventType] = useState(null);
  const [plantId, setPlantId] = useState("");
  const [plantList, setPlantList] = useState([]);
  const [tableRenderData, setTableRenderData] = useState(null);
  const [resBuildingList, setResBuildingList] = useState([]);
  const [buildingDetails, setBuildingDetails] = useState("");
  const [trackMultipleAction, setTrackMultipleAction] = useState(null);

  const plantRef = useRef("");
  const importIntial = {
    isOpen: false,
    headerTitle: localization.importBuild,
    subHeaderTitle: localization.importBuildTitle,
    handleClose: handleCloseImport,
    handleImport: handleImport,
    handleDownloadTemplate: handleDownloadTemplate,
  };
  const [openImport, setOpenImport] = useState(importIntial);
  const columns = [
    { field: "plantId", headerName: localization.plant, hideable: false },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "bau", headerName: localization.headerName },
  ];

  useEffect(() => {
    getPlants();
    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_SUCCESS,
      getPlantSuccess,
    );
    usermanagementStore.addChangeListener(
      UsermanagementConstants.GET_PLANT_FAILURE,
      getPlantFailure,
    );

    return () => {
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_SUCCESS,
        getPlantSuccess,
      );
      usermanagementStore.removeChangeListener(
        UsermanagementConstants.GET_PLANT_FAILURE,
        getPlantFailure,
      );
    };
  }, []);

  const getPlants = () => {
    setGlobalSpinner(true);
    UserManagementActions.getPlantsByUserId();
  };

  const getPlantSuccess = () => {
    const res = usermanagementStore.getPlantResult();
    if (res.length > 0) {
      setPlantList(res);
      setPlantId(res[0].id);
    } else {
      setPlantList([]);
    }
    setGlobalSpinner(false);
  };

  const getPlantFailure = () => {
    setGlobalSpinner(false);
    toast.error("Failed to load plants");
  };

  useEffect(() => {
    if (plantId) {
      plantRef.current = plantId;
      getBuilding(plantId);
    }
  }, [plantId]);

  useEffect(() => {
    function AddOrUpdateBuildSuccess() {
      const res = buildingStore.getAddUpdateBuildResult();
      commonUtils.hideModalPopUp("addBuildingModalClose");
      toast.success(
        commonUtils.getIsEdit()
          ? localization.buildingEdit
          : localization.buildingSave,
      );
      commonUtils.setIsEdit(false);
      getBuilding(plantRef.current);
      setPlantId(plantRef.current);
    }

    function AddOrUpdateBuildFailure() {
      const res = buildingStore.getAddUpdateBuildResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    buildingStore.addChangeListener(
      BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_SUCCESS,
      AddOrUpdateBuildSuccess,
    );

    buildingStore.addChangeListener(
      BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_FAILURE,
      AddOrUpdateBuildFailure,
    );

    return () => {
      buildingStore.removeChangeListener(
        BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_SUCCESS,
        AddOrUpdateBuildSuccess,
      );

      buildingStore.removeChangeListener(
        BuildingConstant.ADD_OR_UPDATE_BUILDING_LIST_FAILURE,
        AddOrUpdateBuildFailure,
      );
    };
  }, []);

  const getBuilding = (plantId) => {
    setGlobalSpinner(true);
    BuildingActions.getBuildingList(plantId);
  };

  useEffect(() => {
    buildingStore.addChangeListener(
      BuildingConstant.GET_BUILDING_LIST_SUCCESS,
      getBuildingListSuccess,
    );
    buildingStore.addChangeListener(
      BuildingConstant.GET_BUILDING_LIST_FAILURE,
      getBuildingListFailure,
    );

    return () => {
      buildingStore.removeChangeListener(
        BuildingConstant.GET_BUILDING_LIST_SUCCESS,
        getBuildingListSuccess,
      );
      buildingStore.removeChangeListener(
        BuildingConstant.GET_BUILDING_LIST_FAILURE,
        getBuildingListFailure,
      );
    };
  }, []);

  useEffect(() => {
    function deleteBuildSuccess() {
      const res = buildingStore.getDelBuildResult();
      setTableRenderData(null);
      if (res.length === 0) {
        toast.success(localization.delbuild);
      } else {
        res.forEach((item) => toast.error(item));
      }
      getBuilding(plantRef.current);
      setPlantId(plantRef.current);
    }

    function deleteBuildFailure() {
      const res = buildingStore.getDelBuildResult();
      toast.error(res);
      setGlobalSpinner(false);
    }

    buildingStore.addChangeListener(
      BuildingConstant.DEL_BUILDING_SUCCESS,
      deleteBuildSuccess,
    );

    buildingStore.addChangeListener(
      BuildingConstant.DEL_BUILDING_FAILURE,
      deleteBuildFailure,
    );

    return () => {
      buildingStore.removeChangeListener(
        BuildingConstant.DEL_BUILDING_SUCCESS,
        deleteBuildSuccess,
      );

      buildingStore.removeChangeListener(
        BuildingConstant.DEL_BUILDING_FAILURE,
        deleteBuildFailure,
      );
    };
  }, []);

  const getBuildingListSuccess = () => {
    const res = buildingStore.getBuildingListResult();
    const tableData = res.map((item) => ({
      id: item.id,
      bau: item.bau,
      plantId: item.plantId,
    }));
    setTableRenderData(tableData);
    setResBuildingList(res);
    setGlobalSpinner(false);
  };

  const getBuildingListFailure = () => {
    setGlobalSpinner(false);
    toast.error("Failed to load buildings");
  };

  const handleAdd = () => {
    plantRef.current = plantId;
    setBuildingDetails("");
    // Code to open modal for adding building
  };

  const handleEdit = (buildingDetails) => {
    plantRef.current = plantId;
    setBuildingDetails(buildingDetails);
    // Code to open modal for editing building
  };

  const handleDelete = (buildingId) => {
    plantRef.current = plantId;
    const _idList = [];
    if (Array.isArray(buildingId)) {
      buildingId.forEach((b) => _idList.push(b.id));
    } else {
      _idList.push(buildingId.id);
    }
    deleteBuildingCallback(_idList);
  };

  const deleteBuildingCallback = (buildingId) => {
    setConfirmationPopUpOpen(true);
    setConfirmationPopUpMsg(localization.deleteConfirmation);
    setCallbackData({ buildID: buildingId });
    setEventType("DELETE_BUILD");
  };

  const confirmationOkCancelCallback = (isConfirmed, eventType, data) => {
    if (isConfirmed && eventType === "DELETE_BUILD") {
      setGlobalSpinner(true);
      BuildingActions.deleteBuilding(plantId, data.buildID);
      closePopUpCallback();
    } else {
      closePopUpCallback();
    }
  };

  const closePopUpCallback = () => {
    setConfirmationPopUpOpen(false);
    setConfirmationPopUpMsg("");
    setCallbackData(null);
    setEventType(null);
  };

  const operations = {
    RowOperationList: [
      { label: "Edit", component: <RenderEditButton />, onClick: handleEdit },
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
    GridToolBarAction: [
      { label: "Add", component: <RenderAddBuilding />, onClick: handleAdd },
      {
        label: "Import",
        component: <RenderImportButton />,
        onClick: handleImportClick,
      },
    ],
    SelectedToolBar: [
      {
        label: "Delete",
        component: <RenderDeleteButton />,
        onClick: handleDelete,
      },
    ],
  };

  function RenderAddBuilding() {
    return (
      <Button
        id="addBuilding"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={handleAdd}
        data-toggle="modal"
        data-target="#addBuildingpopOver"
      >
        {localization.add}
      </Button>
    );
  }

  function handleImportClick() {
    setOpenImport((prev) => ({
      ...prev,
      isOpen: true,
    }));
  }
  function RenderImportButton() {
    return (
      <Button
        id="import"
        className="svgIcon cursorPoint"
        variant="outlined"
        startIcon={<UploadFileOutlinedIcon />}
        onClick={handleImportClick}
      >
        {localization.import}
      </Button>
    );
  }
  function RenderEditButton(props) {
    const currentBuildDetails = props.currentBuild;
    return (
      <Button
        variant="outlined"
        startIcon={<AiOutlineEdit />}
        onClick={() => handleEdit(currentBuildDetails)}
        data-toggle="modal"
        data-target="#addBuildingpopOver"
      >
        {localization.toolTipEdit}
      </Button>
    );
  }

  function RenderDeleteButton(props) {
    const id = props.currentBuild;
    return (
      <Button variant="outlined" startIcon={<AiOutlineDelete />}>
        {localization.delete}
      </Button>
    );
  }

  function handleImport(seletedFile) {
    setGlobalSpinner(true);

    const obj = {
      ImportType: "Building",
      WerkId: plantRef.current,
      ImportFile: seletedFile,
    };
    ImportAction.uploadData(obj);
  }

  function handleCloseImport(_message) {
    if (_message === "success") {
      getBuilding(plantRef.current);
      setPlantId(plantRef.current);
    }
    setOpenImport((prev) => ({
      ...prev,
      isOpen: false,
    }));
  }

  function handleDownloadTemplate() {
    ImportAction.getTemplate({
      ImportType: "Building",
      UpdateTempalte: false,
      WerkId: plantRef.current,
    });
    setGlobalSpinner(true);
  }
  function getAction(params) {
    const _acionList = [];

    _acionList.push(
      <GridActionsCellItem
        label={localization.toolTipEdit}
        showInMenu
        onClick={() => handleEdit(params.row)}
        data-toggle="modal"
        data-target="#addBuildingpopOver"
      />,
    );
    _acionList.push(
      <GridActionsCellItem
        label={localization.delete}
        showInMenu
        onClick={() => handleDelete(params.row)}
      />,
    );

    return _acionList;
  }
  return (
    <>
      <div className="w-100 h-100" id="content">
        {tableRenderData && (
          <CustomDataGrid
            Title={localization.orgSetting + " / " + localization.headerName}
            renderParentComponent={
              <div className="form-group d-flex  align-items-center">
                <label htmlFor="plantList" className="mr-3">
                  {localization.plant}
                </label>
                <select
                  className="form-control"
                  id="plantList"
                  name="plantList"
                  required
                  value={plantId}
                  onChange={(e) => setPlantId(e.target.value)}
                >
                  {plantList.map((row, index) => (
                    <option key={index} value={row.id}>
                      {row.bezeichnung}
                    </option>
                  ))}
                </select>
              </div>
            }
            columns={columns}
            rows={tableRenderData}
            operations={operations}
            onAdd={handleAdd}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={["plantId", "bau"]}
            showCheckBox={true}
            trackMultipleAction={trackMultipleAction}
            setTrackMultipleAction={setTrackMultipleAction}
            gridTableHeight={"dataGridSmall"}
          />
        )}
      </div>
      <AddBuilding
        selectedPlant={plantId}
        plantList={plantList}
        buildingDetails={buildingDetails}
        handlePopOverModelClose={closePopUpCallback}
      />
      {openImport.isOpen && <ImportComponent data={openImport} />}
      <ConfirmationPopUp
        isOpen={confirmationPopUpOpen}
        okCancelCallback={confirmationOkCancelCallback}
        close={closePopUpCallback}
        title=""
        msg={confirmationPopUpMsg}
        eventType={eventType}
        callbackData={callbackData}
      />
    </>
  );
}
